<div class="project-brief-container h-[100%] w-full">
  <!-- <ng-container *ngTemplateOutlet="toggleButton"></ng-container> -->
  <ng-container *ngIf="mode === VIEW_MODE.ADD || mode === VIEW_MODE.EDIT">
    <ng-container *ngTemplateOutlet="projectBriefForm"></ng-container>
  </ng-container>

  <ng-container *ngIf="mode === VIEW_MODE.VIEW">
    <ng-container *ngTemplateOutlet="projectBriefView"></ng-container>
  </ng-container>
</div>

<ng-template #projectBriefForm>
  <app-brief-sections
    [currentStep]="currentStep"
    [projectId]="projectId"
    (projectIdEmitter)="receiveProjectId($event)"
  ></app-brief-sections>
</ng-template>

<ng-template #projectBriefView>
  <app-stage1viewmode
    (changeProjectBriefViewMode)="handleViewChange($event)"
  ></app-stage1viewmode>
</ng-template>

<ng-template #toggleButton>
  <div class="sticky-switch-container">
    <div
      class="mode-toggle"
      [class.edit-mode]="isEditMode"
      (click)="toggleMode()"
    >
      <div class="toggle-option view-option" [class.active]="!isEditMode">
        <span>View</span>
      </div>
      <div
        (click)="clickEditProjectBrief()"
        class="toggle-option edit-option"
        [class.active]="isEditMode"
      >
        <span>Edit</span>
      </div>
    </div>
  </div>
</ng-template>
